import { useTheme } from '@mui/material/styles';

export const Default = ({ color, ...props }) => {
    const theme = useTheme();
    const finalColor = color || theme.palette.figma.white[30];

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="68" viewBox="0 0 22 68" fill="none">
            <path d="M6 13.5H16L21 67.5M0 0.5H6V26.5H0" stroke={finalColor} strokeOpacity="1" />
        </svg>
    );
};

export const Win01 = ({ color, ...props }) => {
    const theme = useTheme();
    const finalColor = color || theme.palette.figma.buttonOrange;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="68" viewBox="0 0 22 68" fill="none">
            <path d="M0 0.5H6V13.5H16L21 67.5" stroke={finalColor} />
        </svg>
    );
};

export const Win02 = ({ color, ...props }) => {
    const theme = useTheme();
    const finalColor = color || theme.palette.figma.buttonOrange;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="55" viewBox="0 0 22 55" fill="none">
            <path d="M0 13.5H6V0.5H16L21 54.5" stroke={finalColor} />
        </svg>
    );
};